import React from 'react';
import { Box, Container, Heading, Flex, Button, ButtonGroup, Divider, HStack, useColorModeValue, Image, Text } from '@chakra-ui/react';
import { ArrowBackIcon, ViewIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Link, useNavigate } from 'react-router-dom';
import TanStackKanban from '../components/leads/TanStack';

/**
 * Page component for displaying the TanStack implementation of the Kanban board
 */
const TanStackKanbanPage = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const navigate = useNavigate();
  
  return (
    <Box bg="#fef4db" minH="100vh" width="100%" overflow="hidden">
      <Box width="100%" overflowY="hidden">
        <Flex 
          justify="space-between" 
          align="center" 
          p={4}
          bg="#fef4db"
        >
          <HStack spacing={3}>
            <Box as="a" href="https://sumaroh.com" target="_blank" rel="noopener noreferrer">
              <Image src="/logo.png" alt="Logo" height="30px" ml={3} />
            </Box>
            <Text color="#63410d" fontSize="xl" fontWeight="thin">|</Text>
            <Heading size="lg" color="#63410d" fontWeight="thin">CRM - TanStack</Heading>
          </HStack>
          
          <ButtonGroup size="sm" spacing={2}>
            <Button
              leftIcon={<ViewIcon />}
              variant="ghost"
              color="#7c5913"
              _hover={{ bg: '#f9e8c0' }}
              onClick={() => navigate('/sheets')}
              size="sm"
            >
              Lead Sync
            </Button>
            
            <Button
              leftIcon={<ChevronUpIcon />}
              variant="ghost"
              color="#7c5913"
              _hover={{ bg: '#f9e8c0' }}
              onClick={() => navigate('/analytics')}
              size="sm"
            >
              Analytics
            </Button>
            
            <Button
              leftIcon={<ArrowBackIcon />}
              variant="ghost"
              color="#7c5913"
              _hover={{ bg: '#f9e8c0' }}
              onClick={() => navigate('/')}
              size="sm"
            >
              Back to Original Board
            </Button>
          </ButtonGroup>
        </Flex>
        
        <Divider borderColor="#e8d6b0" />
        
        <Box pt={0} pb={0} height="calc(100vh - 70px)" overflow="hidden">
          <TanStackKanban />
        </Box>
      </Box>
    </Box>
  );
};

export default TanStackKanbanPage;
